import React from 'react';
import {
    ActivityType,
    ChallengeActivityFilterDto,
    ChallengeFitnessMetricType,
    WorkoutCategory,
    WorkoutTypeV2
} from '@core/api/ChallengeClient';
import {
    ActivityFilterFormValue,
    ActivityFiltersEditor,
    normalizeActivityFilters
} from '@core/activity-filters/editor';
import { fitnessMetricOptions } from './options';

export interface ChallengeActivityFilterFormValue
    extends ActivityFilterFormValue {
    activityType?: ActivityType;
    workoutCategory?: WorkoutCategory;
    workoutType?: WorkoutTypeV2;
    fitnessMetricType?: ChallengeFitnessMetricType;
}

const ACTIVITY_TYPE_OPTIONS = Object.values(ActivityType);
const WORKOUT_CATEGORY_OPTIONS = Object.values(WorkoutCategory);
const WORKOUT_TYPE_OPTIONS = Object.values(WorkoutTypeV2);
const FITNESS_METRIC_OPTIONS = fitnessMetricOptions.map(
    (option) => option.value as string
);

export const challengeActivityFiltersFromDto = (
    filters?: ChallengeActivityFilterDto[]
): ChallengeActivityFilterFormValue[] =>
    (filters || []).map((filter) => ({
        activityType: filter.activityType,
        workoutCategory: filter.workoutCategory,
        workoutType: filter.workoutType,
        hasArrivalLocation: filter.hasArrivalLocation,
        minRawValue: filter.minRawValue,
        maxRawValue: filter.maxRawValue,
        fitnessMetricType: filter.fitnessMetricType
    }));

export const normalizeChallengeActivityFilters = (
    filters: ChallengeActivityFilterFormValue[]
): ChallengeActivityFilterDto[] =>
    normalizeActivityFilters(
        filters,
        ActivityType.WORKOUT
    ) as ChallengeActivityFilterDto[];

interface ChallengeActivityFiltersEditorProps {
    value: ChallengeActivityFilterFormValue[];
    onChange: (value: ChallengeActivityFilterFormValue[]) => void;
    disabled?: boolean;
}

export const ChallengeActivityFiltersEditor: React.FC<
    ChallengeActivityFiltersEditorProps
> = ({ value, onChange, disabled }) => (
    <ActivityFiltersEditor
        value={value}
        onChange={(filters) =>
            onChange(filters as ChallengeActivityFilterFormValue[])
        }
        activityTypeOptions={ACTIVITY_TYPE_OPTIONS}
        workoutCategoryOptions={WORKOUT_CATEGORY_OPTIONS}
        workoutTypeOptions={WORKOUT_TYPE_OPTIONS}
        fitnessMetricOptions={FITNESS_METRIC_OPTIONS}
        workoutActivityType={ActivityType.WORKOUT}
        disabled={disabled}
        showMaxRawValue
        title="Qualifying activity sets"
        helperText="Rows are combined with OR — an activity qualifies if it matches any row. Leave empty to count every activity."
        emptyStateText="No sets configured — every activity qualifies for this challenge."
    />
);
